import React from 'react';
import PropTypes from 'prop-types';
import { CloseSmallIcon } from 'DesignSystem/Icons';

export const AlertTypes = {
  Error: 'error',
  Info: 'info',
  Success: 'success',
  Warning: 'warning',
};

export default class Alert extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: true,
    };

    this.close = this.close.bind(this);
  }

  close() {
    this.setState({
      isOpen: false,
    });
  }

  render() {
    if (!this.state.isOpen) {
      return null;
    }
    const { boldText, children, closeButton, text } = this.props;
    const boldTextDisplayed = text && boldText ? `${boldText} ` : boldText;

    return (
      <div
        className={`ds-alert ds-alert-${this.props.type} ${this.props.className}`}
      >
        <div className="alert-text">
          <b>{boldTextDisplayed}</b>{text}
          {children}
        </div>
        {closeButton &&
          <CloseSmallIcon
            className="ds-icon-default cursor-pointer"
            onClick={this.close}
          />
        }
      </div>
    );
  }
}

Alert.propTypes = {
  boldText: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  closeButton: PropTypes.bool,
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(AlertTypes)).isRequired,
};

Alert.defaultProps = {
  boldText: '',
  children: null,
  className: '',
  closeButton: false,
};



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Notifications/Alert.jsx